/**
 * AgencyBadge — the agency's logo + name + email, shown in the header, the
 * sidebar "Agency Information" card and the sticky footer.
 *
 * Props:
 *   - agency   {{ logo, name, email }} — agency view-model (from mapAgency / mock);
 *              email renders as a mailto link (opens in a new tab)
 *   - compact  {boolean}               — slightly smaller avatar for the sidebar card
 *   - hideLogo {boolean}               — omit the avatar (the desktop header shows
 *                                        the large logo separately, above the row)
 */
import React from 'react';
import { mailtoHref } from './contactLinks';

export default function AgencyBadge({ agency, compact, hideLogo }) {
    return (
        <div className="rs-agency">
            {!hideLogo && (
                <img className="rs-avatar" src={agency.logo} alt={agency.name}
                    style={compact ? { width: 58, height: 58 } : undefined} />
            )}
            <div>
                <p className="rs-agency__name">{agency.name}</p>
                {agency.email && (
                    <a className="rs-agency__mail" href={mailtoHref(agency.email)}>
                        {agency.email}
                    </a>
                )}
            </div>
        </div>
    );
}
